<h2
    mat-dialog-title
    class="tt-danger-background"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragBoundary=".cdk-overlay-container"
    cdkDragHandle
    ttTranslateWord="tt_cancel_orderhead_title"
></h2>
<mat-dialog-content class="order-head-cancel-dialog__content">
    <tt-select ttLabel="orderlinecancelcause_name" [(ttModel)]="cause" [ttData]="cancellationCauses" ttDataId="item_parms"></tt-select>
    <tt-textarea ttLabel="orderhead_cancellation_note" [(ttModel)]="note"></tt-textarea>
</mat-dialog-content>
<mat-dialog-actions align="end" class="order-head-cancel-dialog__actions">
    <tt-button ttType="warning" ttText="tt_cancel_orderhead_abort" (ttClick)="dialogRef.close()"></tt-button>
    <tt-button ttType="danger" ttText="tt_cancel_orderhead_confirm" (ttClick)="confirm()"></tt-button>
</mat-dialog-actions>
